import * as z from 'zod';

import { LosId } from '../../BrandedIds';
import { DateString, NonNegativeMonetaryValue } from '../fields';

export const UpdateSubsidySettingRow = z.object({
  loanId: LosId,
  effectiveDate: DateString.describe(
    'Effective date of the existing subsidy setting to update (used to match the setting, not changed)',
  ),
  amount: NonNegativeMonetaryValue.describe(
    'New monthly subsidy amount as of that effective date. Cannot exceed the loan’s total payment (PITI)',
  ),
});

export type UpdateSubsidySettingRow = z.infer<typeof UpdateSubsidySettingRow>;

export const UPDATE_SUBSIDY_SETTING_ROW_REQUIRED_FIELDS = Object.keys(UpdateSubsidySettingRow.shape).filter(
  (key) => !UpdateSubsidySettingRow.shape[key as keyof typeof UpdateSubsidySettingRow.shape].isOptional(),
) as (keyof UpdateSubsidySettingRow)[];
